<template>
  <AddToBag />
</template>

<script>
import AddToBag from "@/components/add-to-bag/AddToBag.vue";

export default {
  name: "GlobalComponent",
  components: {
    AddToBag,
  },
};
</script>
